export default __webpack_public_path__ + "static/media/contact.61a9cddb.svg";